module.exports = __webpack_public_path__ + "img/bukit_mertajam.5d9bf5a6.png";